<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/wo">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              Work Order Manifest
              <small class="m-display-block m-text-small">{{
                data.manifest.no_wo
              }}</small>
            </div>
            <a-popover v-model="visiblemenupopover" slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrint"
                    :disabled="!data.print_btn"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    >Manifest</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.manifest.prepared_by">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.lastStatus == 'Revised' &&
                          getAuth.username == data.manifest.prepared_by &&
                          data.revised_flag
                        ) && !data.cancel_sts
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="data.cancel_btn=='disabled'"
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                    <a-button
                      @click="handleclosetrans"
                      :disabled="data.close_btn!='enabled'"
                      type="primary"
                      icon="check"
                      >Close</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{ data.manifest.tgl_wo }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No PP</span>
                  <span class="m-list-desc">{{ data.manifest.no_pp }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Supplier</span>
                  <span class="m-list-desc">{{ data.manifest.kepada }}<br/>
                    (PKP : {{ data.manifest.ispkp }} , Domestik : {{ data.manifest.domestik }})</span>
                </li>
                <li>
                  <span class="m-list-title" for>Location</span>
                  <span class="m-list-desc">{{ data.manifest.lokasi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.catatan }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>Tax</span>
                  <span class="m-list-desc">{{data.manifest.pajak}}</span>
                </li> -->
              </ul>
            </div>
          </a-card>

          <a-card class="margin-top margin-bottom" v-if="getScreen">
            <div slot="title">Work Detail</div>
            <div slot="extra">
              <a-button
                @click="handleviewhistPaymentrefund"
                type="default"
                size="small"
                class="margin-right-small"
                icon="undo"
                v-if="data.button_history"
              >
                History
              </a-button>
            </div>
            <a-list
              itemLayout="vertical"
              :dataSource="dtabel"
              :pagination="pagination"
            >
              <Empty
                v-if="data.detail ? data.detail.length <= 0 : data.detail"
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <span slot="title">{{ item.job }}</span>
                  <div slot="description" class="margin-remove">
                    <div class="m-display-flex space-between">
                      <span>{{ item.jumlah }}&nbsp;{{ item.satuan }}</span>
                      <div>
                        <h4 class="margin-remove m-text-align right">
                          @ {{ formatCurrency(data.currency, item.harga) }}
                        </h4>
                      </div>
                    </div>
                    <h3 class="margin-remove m-text-align right">
                      Sub Total :
                      {{ formatCurrency(data.currency, item.total_harga) }}
                    </h3>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
            <div class="m-price-total">
              <h3 class="margin-remove m-text-align right">
                Total : {{ formatCurrency(data.currency, data.keuangan.total) }}
              </h3>
              <!-- <h3
                class="margin-remove m-text-align right"
              >Tax ({{data.keuangan.pajak}}) : {{formatCurrency(data.currency,data.keuangan.nilaiPajak)}}</h3> -->
              <h3
                v-for="item in dlist"
                :key="item.id_dtl"
                class="margin-remove m-text-align right"
              >
                {{ item.job }}
                {{ item.persen !== null ? "(" + (item.tax_type=='bea_masuk' || item.tax_type=='ppn' ? item.persen : item.persen*-1) + "%) : " : " : " }}
                {{ item.kategori=="1" ? "-" : "" }}
                {{ formatCurrency(currency, item.total_harga) }}
              </h3>

              <div style="display: flex;flex-direction: row-reverse">
                
                <h3 class="margin-remove m-text-align right" v-if="displaylistrefund">
                  Refund : {{ formatCurrency(data.currency, data.total.refundTotal) }}
                </h3>

                <a-button
                style="margin-right: 10px"
                @click="handleViewclosetrans"
                type="default"
                icon="eye"
                size="small"
                class="margin-top"
                >View</a-button>
              </div>

              <a-statistic
                title="Total Bill"
                :value="formatCurrency(data.currency, data.keuangan.grandTotal)"
                class="margin-top m-text-align right"
              />
            </div>
            
          </a-card>

          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
            <div
                class="m-display-flex space-between align-middle"
                slot="header"
            >
              <h4 class="margin-remove">Work Detail</h4>
              <div>
                <a-button
                  @click="handleviewhistPaymentrefund"
                  type="default"
                  size="small"
                  class="margin-right-small"
                  icon="undo"
                  v-if="data.button_history"
                >
                  History
                </a-button>
              </div>
            </div>

              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="dtabel"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="unit_price" slot-scope="unit_price">
                  <CurrencyJustified
                    :currencyValue="data.currency"
                    :valueNumber="unit_price"
                  />
                </span>
                <span slot="ppdtl" slot-scope="ppdtl">
                  <b>{{ ppdtl.nama_barang_pp }}</b
                  ><br />
                  <p>{{ ppdtl.kode_anggaran }}</p>
                </span>
                <span slot="amount" slot-scope="amount">
                  <CurrencyJustified
                    :currencyValue="data.currency"
                    :valueNumber="amount"
                  />
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="10" :order="1" class="m-text-align left">
                      <b>Sub Total</b>
                    </a-col>
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align right m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                      :deci2="true"
                        v-if="data.currency"
                        :currencyValue="data.currency"
                        :valueNumber="data.keuangan.total"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex" v-for="item in dlist" :key="item.id_dtl">
                    <a-col :span="10" :order="1" class="m-text-align left">
                      {{ item.item_name }}
                      {{ item.persen !== null ? "(" + item.persen + "%)" : "" }}
                      <template v-if="item.tax_type">
                        <br/>
                        <i>{{item.tax_type && item.tax_type.includes("pph") ? (item.tax_bearer=="1" ? "(Supplier Tax Bearer)": "(Infoglobal Tax Bearer)") : ""}}</i>
                      </template>
                    </a-col>
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align right m-text-bold"
                    >
                    <!-- {{ item.kategori=="1" ? "-" : "" }} -->
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified 
                        :deci2="true"
                        v-if="item.total_harga"
                        :currencyValue="data.currency"
                        :valueNumber="item.total_harga"
                      />
                    </a-col>
                  </a-row>
                  <a-divider class="margin-small" />
                  <a-row type="flex">
                    <a-col :span="10" :order="1" class="m-text-align left">
                      <b>Total Bill</b>
                    </a-col>
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align right m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                      :deci2="true"
                        v-if="data.currency"
                        :currencyValue="data.currency"
                        :valueNumber="data.keuangan.grandTotal"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex" v-if="displaylistrefund">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Refund</a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        v-if="data.total.refundTotal"
                        :currencyValue="data.currency"
                        :valueNumber="data.total.refundTotal"
                      />
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      &nbsp;
                      <a-button
                      @click="handleViewclosetrans"
                      type="default"
                      icon="eye"
                      size="small"
                      >View</a-button
                    >
                    </a-col>
                  </a-row>
                </div>
              </a-table>
              <i v-if="anyPPH" style="color:red">* PPh is not calculated </i>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            :wrapper-col="{ span: 24 }"
            class="margin-top"
            :loading="loading"
            v-if="
              data.jenis.toLowerCase() === 'verifikator' ||
              data.jenis.toLowerCase() === 'approve'
            "
          >
            <div slot="title">Manifest Actions</div>
            <a-row :gutter="16">
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    v-decorator="[
                      'aksi',
                      {
                        rules: [{ required: true }],
                        initialValue: data.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option
                      v-for="item in data.aksi"
                      :key="item.aksi"
                      >{{ item.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>
                <a-form-item>
                  <a-button
                    :loading="loading"
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-row>
          </a-card>

          <a-card
            class="margin-top"
            :loading="loading"
            v-if="
              data.jenis.toLowerCase() === 'transfer' ||
              data.jenis.toLowerCase() === 'Manifest'
            "
          >
            <!-- <div slot="title">Manifest Actions</div> -->
            <div slot="title">
              Manifest Actions &nbsp;<i
                v-if="data.jenis == 'Transfer' && !data.status_transfer"
                style="color: red !important"
                >(Funding has not been set)</i
              >
            </div>
            <div slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(data.currency, sisa_tf)
              }}</a-tag>
            </div>
            <template
              v-if="!(data.jenis == 'Transfer' && !data.status_transfer)"
            >
              <a-form :form="formTransfer">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length > 0"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: true }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-width-full m-text-align right"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    :loading="loading"
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse
            :class="getScreen ? 'margin-top' : ''"
            activeKey="1"
            v-if="data.buktiTransfer.length > 0"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Evidence of Transfer</h4>
              </div>
              <div>
                <a-alert
                  v-if="
                    data.buktiTransfer === undefined ||
                    data.buktiTransfer === null
                  "
                  type="error"
                  message="No evidence of transfer was uploaded"
                  banner
                />

                <ul
                  class="m-list-wrapper bordered"
                  v-for="(bukti, index) in data.buktiTransfer"
                  :key="index"
                >
                  <li>
                    <div slot="title" class="m-display-flex space-between">
                      <span class="m-list-title">
                        {{
                          index +
                          1 +
                          ". " +
                          moment(bukti.tgl_tf).format(dateFormatTf) +
                          " - " +
                          data.currency +
                          formatRupiah(bukti.value_tf).replace("Rp", "") +
                          " | " +
                          bukti.user_tf
                        }}
                      </span>
                      <a-button
                        @click="handleViewFile(bukti)"
                        size="small"
                        type="default"
                        icon="eye"
                        >View</a-button
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse
            :class="data.buktiTransfer.length == 0 ? '' : 'margin-top'"
            activeKey="1"
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transaction Status</h4>
                <div>
                  <Status :status="data.lastStatus" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.manifest.prepared_by }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ moment(data.manifest.tgl_wo).format(
                          getDateTimeStandartFormat) }}</h4>
                    <span
                      class="m-text-small"
                      v-if="
                        data.manifest.catatan === null ||
                        data.manifest.catatan === ''
                      "
                      >Tidak Ada Catatan</span
                    >
                    <span class="m-text-small" v-else>{{
                      data.manifest.catatan
                    }}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="
                        !workflow.remark ||
                        workflow.remark === null ||
                        workflow.remark === ''
                      "
                      >Tidak Ada Catatan</span
                    >
                    <span class="m-text-small" v-else>{{
                      workflow.remark
                    }}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse
            class="margin-top"
            activeKey="1"
            v-if="
              data.jenis === 'Manifest' ||
              data.jenis === 'Verifikator' ||
              data.jenis === 'Transfer'
            "
          >
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Account Pay</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.ap">
                <Empty v-if="data.ap ? data.ap.length <= 0 : data.ap" />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <span class="margin-remove m-text-dots">
                        {{ item.title ? item.title : "-" }}
                      </span>
                      <a-button
                        @click="handleViewDoc(item)"
                        icon="eye"
                        size="small"
                        >View</a-button
                      >
                    </div>
                    <div slot="description">
                      <a-row>
                        <a-col span="6">No Invoice</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.no_invoice }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Due Date</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.due_date }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Value</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{
                          formatCurrency(data.currency, item.value)
                        }}</a-col>
                      </a-row>
                      <a-row>
                        <a-col span="6">Catatan</a-col>
                        <a-col span="1">:</a-col>
                        <a-col span="15">{{ item.description }}</a-col>
                        <!-- <Status :status="item.status_bkk" /> -->
                      </a-row>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <!-- v-if="data.jenis === 'Manifest' || data.jenis === 'Verifikator' || data.jenis === 'Transfer'" -->
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button
                    @click="addLampiran"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.lampiran">
                <Empty
                  v-if="
                    data.lampiran ? data.lampiran.length <= 0 : data.lampiran
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title">
                      <a
                        @click="handleDownload(item)"
                        class="margin-remove m-text-dots"
                      >
                        {{ item.jenis ? item.jenis : "-" }}
                      </a>
                    </div>
                    <div slot="description">
                      <div class="m-display-flex space-between nowrap">
                        <h4 class="margin-remove m-text-dots">
                          {{ item.fungsi }}
                        </h4>
                        <a-button
                          v-if="data.manifest.prepared_by === getAuth.username"
                          @click="handleRemoveExisting(item.id_wo_doc)"
                          size="small"
                          type="danger"
                          icon="delete"
                        ></a-button>
                      </div>
                      {{ item.tanggal }} | {{ item.tlc }}
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      v-if="getScreen"
                      class="m-display-flex space-between align-middle"
                    >
                      <h4
                        v-if="item.rest_api === 'supplier'"
                        class="m-list-dots margin-remove"
                      >
                        {{ item.header }}
                      </h4>
                      <h4 v-else class="m-list-dots margin-remove">
                        {{ item.header }} || {{ item.tlc }}
                      </h4>
                      <div>
                        <Status :status="item.status" />
                        <a-button
                          @click="handleView(item)"
                          size="small"
                          type="default"
                          icon="eye"
                          >View</a-button
                        >
                      </div>
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-else
                    >
                      <h4
                        v-if="item.rest_api === 'supplier'"
                        class="m-list-dots margin-remove"
                      >
                        {{ item.header }}
                      </h4>
                      <h4 v-else class="m-list-dots margin-remove">
                        {{ item.header + " | " + item.tlc }}
                      </h4>
                      <Status :status="item.status" />
                    </div>
                    <span>{{ item.tgl }}</span>
                    <div slot="description">
                      <span
                        class="m-display-block"
                        v-if="item.deskripsi === null || item.deskripsi === '-'"
                        >Tidak Ada Deskripsi</span
                      >
                      <span
                        class="m-display-block"
                        v-else-if="item.rest_api === 'supplier'"
                        >{{ item.no_manifest }}</span
                      >
                      <span class="m-display-block" v-else>{{
                        item.deskripsi
                      }}</span>
                      <div
                        slot="title"
                        v-if="
                          item.estimated_value && item.rest_api !== 'supplier'
                        "
                      >
                        <span class="m-timeline-title">{{
                          formatCurrency(item.currency, item.estimated_value)
                        }}</span>
                      </div>
                      <a-button
                        v-if="!getScreen"
                        @click="handleView(item)"
                        class="margin-top"
                        type="dashed"
                        icon="eye"
                        >View Document</a-button
                      >
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
            <!-- <a-collapse-panel class="margin-top" key="1">
              <div class="m-display-flex space-between align-middle" slot="header">
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list itemLayout="horizontal" :dataSource="data.dokumen_terkait">
                <Empty v-if="data.dokumen_terkait ? data.dokumen_terkait.length<=0 : data.dokumen_terkait"/>
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" class="m-display-flex space-between align-middle">
                      <a @click="handleView(item)">{{item.header}} | {{item.tlc}}</a>
                      <Status :class="!getScreen ? 'margin-remove' : ''" :status="item.status"/>

                    </div>
                    <div slot="title" class="m-display-flex space-between align-middle" v-if="item.no_manifest">
                      <span>{{item.no_manifest}}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span>{{moment(item.tgl_mulai_dinas,getStandartFormatDate).format(getDefaultDateFormat)}} - {{moment(item.tgl_selesai_dinas,getStandartFormatDate).format(getDefaultDateFormat)}}</span>
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip class="ant-tooltip-inner" placement="top" :title="item.deskripsi ? item.deskripsi : 'Tidak ada deskripsi'">
                        <span
                                class="ant-description-ellipses"
                        >{{item.deskripsi ? item.deskripsi : 'Tidak ada deskripsi'}}</span>
                        </a-tooltip>

                      </div>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span class="m-timeline-title">{{formatCurrency(data.mata_uang,item.value_transaksi)}}</span>
                    </div>

                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>-->
          </a-collapse>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }"></a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
    >
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachments
      </span>

      <a-form :form="formLampiran">
        <a-form-item label="Document Type">
          <a-select v-decorator="['jenis', { rules: [{ required: true }] }]">
            <!-- <a-select-option value="COC">COC</a-select-option>
            <a-select-option value="Test Report">Test Report</a-select-option>
            <a-select-option value="Packing Report">Packing Report</a-select-option>
            <a-select-option value="QC Report">QC Report</a-select-option> -->
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Document Description">
          <a-input
            autocomplete="off"
            v-decorator="['fungsi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Upload Document File">
          <a-upload
            :remove="handleRemove"
            v-decorator="[
              'file_list_lampiran',
              { rules: [{ required: true }] },
            ]"
            :fileList="fileListLampiran"
            :disabled="fileListLampiran.length > 0"
            :beforeUpload="beforeUpload"
          >
            <a-button> <a-icon type="upload" />Select File </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleUploadLampiran"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-model="visibleCloseForm"
      width="50%"
    >
      <span slot="title">
        Close Transaction
      </span>

      <a-table
        key="Idrefund1"
        rowKey="Idrefund1"
        :columns="columnsclosewo"
        :dataSource="tableClosewo.data"
        :pagination="false"
        size="small"
        :loading="loadtableclose"
        bordered
        :scroll="{ y: 400, x: 400 }"
      >
        <span slot="pp_dtl" slot-scope="pp_dtl">
          <b>{{ pp_dtl.nama_barang }}</b
          ><br/>
          {{ pp_dtl.kode_anggaran }}
        </span>
        <template  slot="ppdtl_val" slot-scope="text, record, index">
          <a-input
            style="margin: -5px 0"
            class="m-width-full m-text-align right"
            :min="0.0"
            :value="text"
            @keydown="onlyNumber"
            @change="e => handleChangeClosewo(e.target.value, record.id_pp_dtl, 'value')"
          />
        </template>
        <div slot="footer" class="padding-all">
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              >Total</a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                :currencyValue="tableClosewo.currency"
                :valueNumber="tempvalClosewo"
              />
            </a-col>
          </a-row>

          <a-divider class="margin-small" />
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              >Total Refund</a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="tableClosewo.sisa_transfer"
                :currencyValue="tableClosewo.currency"
                :valueNumber="tableClosewo.sisa_transfer"
              />
            </a-col>
          </a-row>
        </div>
      </a-table>
      <template slot="footer">
        <a-button key="submit" :disabled="disabledClosetranswo" type="primary" @click="saveCloseForm">
          Save
        </a-button>
      </template>
    </a-modal>

    <a-modal
      v-model="visibleCloseFormview"
      :footer="null"
      :width="!getScreen ? '50%' : '80%'"
    >
      <span slot="title">
        Refund Transaction
      </span>

      <a-table
        key="refund2"
        rowKey="refund2"
        :columns="columnsclosewoview"
        :dataSource="data.refund"
        :pagination="false"
        size="small"
        :loading="loadtableclose"
        bordered
        :scroll="{ y: 400, x: 400 }"
      >
        <span slot="pp_dtl" slot-scope="pp_dtl">
          <b>{{ pp_dtl.nama_barang }}</b
          ><br/>
          {{ pp_dtl.kode_anggaran }}
        </span>
        <template  slot="ppdtl_val" slot-scope="record">
          <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="record.refund"
              />
        </template>
        <div slot="footer" class="padding-all">
          <a-row type="flex">
            <a-col :span="!getScreen ? 5 : 8" :order="1" class="m-text-align left"
              >Total Refund</a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                :currencyValue="data.currency"
                :valueNumber="data.total.refundTotal"
              />
            </a-col>
          </a-row>
        </div>
      </a-table>
    </a-modal>

    <a-modal
      v-model="modalhistPaymentrefund"
      :footer="null"
      :width="'80%'"
    >
      <span slot="title">
        History Before Payment Refund
      </span>
      <a-input-search
        v-model="histpaymentRefundsearch"
        placeholder="Quick Search"
        allowClear
        class="margin-bottom"
      />
      <a-table
        :rowKey="(record, index) => {return index;}"
        :columns="columnshistrefundpayment"
        :dataSource="histpaymentData"
        :pagination="pagination"
        size="small"
        bordered
        :scroll="{ x: 950 }"
      >
        <span slot="no" slot-scope="text,record,index">
          {{index+1}}
        </span>
        <span slot="item_PN" slot-scope="item_PN">
          <b>{{ item_PN.job }}</b
          ><br />
          <!-- {{
            item_PN.item_pn || item_PN.item_pn !== ""
              ? "PN : " +
                (item_PN.item_pn == null ? "-" : item_PN.item_pn)
              : ""
          }}<br />{{ "( "+item_PN.type_item +" )"}}<br /> -->
        </span>
        <span slot="ppdtl" slot-scope="ppdtl">
          {{ ppdtl.nama_barang_pp }}<br />
          <i> {{ ppdtl.kode_anggaran }}</i>
        </span>
        <span slot="quantity" slot-scope="text,record">
          {{record.jumlah}} {{record.satuan}}
        </span>
        <span slot="unit_price" slot-scope="unit_price">
          <CurrencyJustified
            :currencyValue="data.currency"
            :valueNumber="unit_price.harga === 0 ? 0.0 : unit_price.harga"
          />
        </span>
        <span slot="amount" slot-scope="amount">
          <CurrencyJustified
            :currencyValue="data.currency"
            :valueNumber="amount.jumlah*amount.harga"
          />
        </span>
        <div slot="footer" class="padding-all">
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              ><b>Total</b></a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="data.total.totalitem_historypaymentrefund"
                :currencyValue="data.currency"
                :valueNumber="data.total.totalitem_historypaymentrefund"
              />
            </a-col>
          </a-row>

          <a-row
            type="flex"
            v-for="(item, index) in histpaymentDataother"
            :key="index"
          >
            <a-col :span="5" :order="1" class="m-text-align left">
              {{ item.nama_barang }}
              {{ item.persen !== null ? "(" + item.persen + "%)" : "" }}
            </a-col>
            <a-col
              :span="1"
              :order="2"
              class="m-text-align right m-text-bold"
            >
              <!-- {{ item.kategori == "1" ? "-" : "" }} -->
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="item.total_harga"
                :currencyValue="data.currency"
                :valueNumber="item.total_harga"
              />
            </a-col>
          </a-row>

          <a-divider class="margin-small" />
          <a-row type="flex">
            <a-col :span="5" :order="1" class="m-text-align left"
              ><b>Total Bill</b></a-col
            >
            <a-col
              :span="1"
              :order="2"
              class="m-text-align left m-text-bold"
            >
            </a-col>
            <a-col
              :span="6"
              :order="3"
              class="m-text-align left m-text-bold"
            >
              <CurrencyJustified
                v-if="data.total.grandTotal_historypaymentrefund"
                :currencyValue="data.currency"
                :valueNumber="data.total.grandTotal_historypaymentrefund"
              />
            </a-col>
          </a-row>
        </div>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "manifestWO",
  components: { Status },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  data() {
    return {
      printLoad: {
        manifest: false,
        cancel: false,
      },
      loading: true,
      visibleHistory: false,
      data: {
        print_btn: false,
        detail: [],
        dokumen_terkait: [],
        keuangan: {},
        manifest: {},
        status: [],
        history: [],
        buktiTransfer: {},
        jenis: "",
        currency: "",
        aksi: [],
        total: {
          refundTotal:0,
        },
        button_history: false,
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      lastStatus: "",
      dateFormat: "DD MMMM YYYY",
      dateFormatTf: "DD/MM/YYYY",
      urlDownload: "",
      reqFileTf: true,
      fileList: [],
      sisa_tf: 0,
      temp_sisa_tf: 0,
      disableNilaiTf: true,
      previewImage: "",
      tableData: [],
      tableDataTemp: [],
      search: "",
      checkTransferValue: true,
      visibleLampiran: false,
      fileListLampiran: [],
      dtabel: [],
      dtemptabel: [],
      dlist: [],
      tableClosewo: [],
      disabledClosetranswo: true,
      displaylistrefund: false,
      visibleCloseFormview: false,
      visibleCloseForm: false,
      loadtableclose: false,
      visiblemenupopover: false,
      modalhistPaymentrefund:false,
      histpaymentRefundsearch:undefined,
      histpaymentData: [],
      histpaymentDatatemp: [],
      histpaymentDataother: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formTransfer = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth", "getIsSpecialMenu","getDateTimeStandartFormat"]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 50,
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          dataIndex: "item_name",
          width: 200,
          key: "item_name",
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Dtl",
          //dataIndex: "item_name",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Note",
          dataIndex: "catatan_dtl",
          key: "catatan_dtl",
          width: 150,
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          width: 100,
          scopedSlots: { customRender: "amount" },
        },
      ];
      return kolom;
    },

    columnsclosewo() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "PP Detil",
          width: 150,
          key: "pp_dtl",
          scopedSlots: { customRender: "pp_dtl" },
          sorter: (a, b) => a.nama_barang.length - b.nama_barang.length,
        },
        {
          title: "Value",
          width: 50,
          dataIndex: "value",
          key: "ppdtl_val",
          scopedSlots: { customRender: "ppdtl_val" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
      ];
      return kolom;
    },

    columnsclosewoview() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "PP Detil",
          width: 150,
          key: "pp_dtl",
          scopedSlots: { customRender: "pp_dtl" },
          sorter: (a, b) => a.nama_barang.length - b.nama_barang.length,
        },
        {
          title: "Value",
          width: 50,
          key: "pp_dtl_val",
          scopedSlots: { customRender: "ppdtl_val" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
      ];
      return kolom;
    },

    searching() {
      if (this.search) {
        this.tableData = this.tableDataTemp.filter(
          (obj) =>
            obj.kategori &&
              obj.kategori=="0" || obj.kategori==null
        );
        this.dtabel = this.tableData.filter(
          (obj) =>
            (obj.item_name &&
              obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
            (obj.kode_anggaran &&
              obj.kode_anggaran
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.nama_barang_pp &&
              obj.nama_barang_pp
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      if (!this.search) {
        this.dtabel = this.tableDataTemp.length==0 ? this.tableDataTemp : this.tableDataTemp.filter(
          (obj) =>
            obj.kategori &&
              obj.kategori=="0" || obj.kategori==null
        ) ;
      }

      return this.dtabel;
    },
    tempvalClosewo(){
      let rest = 0;
      if(this.tableClosewo.data){
        for (let index = 0; index < this.tableClosewo.data.length; index++) {
          rest = rest + Number(this.tableClosewo.data[index].value);
        }
      }
      return rest;
    },
    columnshistrefundpayment() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no" },
          width: 50,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_PN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          key: "quantity",
          width: 100,
          scopedSlots: { customRender: "quantity" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          key: "unit_price",
          scopedSlots: { customRender: "unit_price" },
          width: 100,
        },
        {
          title: "Amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
          width: 100,
        },
      ];
      return kolom;
    },
    anyPPH() {
      let r = _.filter(this.dlist, (item) => item.tax_type && item.tax_type.indexOf("pph") >= 0);
      return r.length>0
    }
  },
  methods: {
    moment,
    handleDownload(item) {
      if (item.source === "simfoni") {
        window.open(this.$serviceUrl + item.url, "_blank");
      } else {
        window.open(item.url, "_blank");
      }
    },
    handleRemoveLampiran(item) {
      const serviceUrl = this.$serviceUrl;
      const auth = {
        username: this.getAuth.username,
        password: this.getAuth.password,
        apikey: this.getAuth.apikey,
      };
      Axios({
        method: "delete",
        url: serviceUrl + "wo/lampiran",
        processData: false,
        data: {
          id_wo_doc: item,
        },
        auth: {
          username: auth.username,
          password: auth.password,
        },
        headers: {
          "X-API-KEY": auth.apikey,
        },
      })
        .then((response) => {
          Event.$emit("refresh", true);
          if (response.data.message === "Delete Success") {
            this.displayMessage("success-del");
          } else {
            let responses = Object.assign({}, response.data);
            this.displayMessageValue("error", responses);
          }
        })
        .catch((err) => {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        });
    },
    handleRemoveExisting(id) {
      this.confirmMessageValue("confirm-delete", id);
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "wo/upload_lampiran",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            this.$router.go(0);
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    cancelLampiran() {
      this.fileListLampiran = [];
      this.formLampiran.resetFields();
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    fetchManifest() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "wo",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let ttlrefund = 0;
          if (response.data.refund){
            this.displaylistrefund = true;
            for (let index = 0; index < response.data.refund.length; index++) {
              ttlrefund = ttlrefund + Number(response.data.refund[index].refund);
            }
          }
          this.data = {
            print_btn: response.data.print_btn,
            catatan: (response.data.header.catatan=='' ? '-' :
              response.data.header.catatan),
            ap: response.data.ap,
            manifest: response.data.header,
            detail: response.data.detail,
            status: response.data.status_app,
            history: response.data.notifikasi,
            dokumen_terkait: response.data.dokumen_terkait,
            lampiran: response.data.lampiran,
            buktiTransfer: response.data.buktiTransfer,
            revised_flag:
              response.data.header.revised_flag == "1" ? true : false,
            cancel_sts: response.data.header.cancel_sts == "2" ? true : false,
            keuangan: {
              total: response.data.totalitem,
              grandTotal: response.data.granTotal,
              pajak: response.data.pajak,
              nilaiPajak:
                (parseFloat(response.data.pajak) / 100.0) *
                response.data.subtotal,
              sudah_tf: response.data.sudah_tf,
            },
            currency: response.data.currency,
            jenis: response.data.jenis,
            status_transfer: response.data.status_transfer,
            aksi: response.data.aksi,
            total :{
              refundTotal: ttlrefund,
            },
            refund: response.data.refund,
            close_btn: response.data.close_btn,
            cancel_btn: response.data.cancel_btn,
            button_history: response.data.history,
          };
          this.data.lastStatus = response.data.last_status;
          this.tlc = this.getAuth.username;
          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;

          if (!this.getScreen) {
            let dataPemakaian = response.data.detail;
            response.data.detail.forEach((value, index) => {
              dataPemakaian[index]["no"] = index + 1;
              dataPemakaian[index]["key"] = index + 1;
              dataPemakaian[index]["item_name"] = value.job;
              dataPemakaian[index]["quantity"] =
                value.jumlah + " " + value.satuan;
              dataPemakaian[index]["unit_price"] = Number(value.harga);
              dataPemakaian[index]["amount"] = Number(value.total_harga);
            });

            this.tableData = dataPemakaian;
            this.tableDataTemp = dataPemakaian;
          }

          this.dtabel = [];
          this.dtemptabel = [];
          this.dlist = [];
          let tempdtl = response.data.detail;
          for (let index = 0; index < tempdtl.length; index++) {
            const element = tempdtl[index];
            if (tempdtl[index].kategori == "0") {
              this.dtabel.push(element);
              this.dtemptabel.push(element);
            } else {
              this.dlist.push(element);
            }
          }

          this.histpaymentData = [];
          this.histpaymentDatatemp = [];
          this.histpaymentDataother = [];
          let tempdtl2 = response.data.detail_history;
          let totalhistpaymentother = 0;
          for (let index = 0; index < tempdtl2.length; index++) {
            const element = tempdtl2[index];
            if (tempdtl2[index].kategori == "0") {
              this.histpaymentData.push(element);
              this.histpaymentDatatemp.push(element);
            } else {
              this.histpaymentDataother.push(element);
              totalhistpaymentother += (element.jumlah * element.harga);
            }
          }

          this.data.total.totalitem_historypaymentrefund = response.data.total_item_history;
          this.data.total.grandTotal_historypaymentrefund = 
            Number(this.data.total.totalitem_historypaymentrefund) + totalhistpaymentother;

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle() {
      this.visibleHistory = !this.visibleHistory;
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
      this.loading = true;
      if (this.data.jenis === "Transfer") {
        this.formTransfer.validateFields((err, values) => {
          if (err) {
            this.loading = false;
            return;
          }
          let formData = new FormData();

          if (values.status === "Revised") {
            formData.append("tlc", this.getAuth.username);
            formData.append("id_wo", this.id);
            formData.append("remark", values.catatan ? values.catatan : "");
            formData.append("status", values.status);
            formData.append("cek_value", this.cek_value);
            formData.append("value_transfer", values.value_transferan);
            formData.append(
              "tgl_transfer",
              moment(values.tgl_tf).format(this.getStandartFormatDate)
            );
          } else if (values.status === "Transferred") {
            formData.append("tlc", this.getAuth.username);
            formData.append("id_wo", this.id);
            formData.append("remark", values.catatan ? values.catatan : "");
            formData.append("status", values.status);
            formData.append("cek_value", this.cek_value);
            formData.append("value_transfer", values.value_transferan);
            formData.append("file_transfer", values.file_transfer.file);
            formData.append(
              "tgl_transfer",
              moment(values.tgl_tf).format(this.getStandartFormatDate)
            );
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "wo/approval",

            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "wo/approval",
            processData: false,
            data: {
              id_wo: this.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan ? values.catatan : "",
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
      this.loading = false;
    },
    onChangeStatus(val) {
      if (val === "Revised") {
        this.reqFileTf = false;
        this.checkTransferValue = false;
        this.fileList = [];
        this.$nextTick(() => {
          this.form.validateFields(["file_transfer"], { force: true });
        });
      } else if (val === "Transferred") {
        this.reqFileTf = true;
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
        this.$nextTick(() => {
          this.form.validateFields(["file_transfer"], { force: true });
        });
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 2) {
        this.displayMessage("large-file-2mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handleViewFile: function (item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleViewDoc(item) {
      const data = {
        id_manifest: item.id_account_pay,
        rest_api: "accountpay",
      };
      this.handleView(data);
      // window.open(this.$serviceUrl + item.ap_doc, "_blank");
    },
    handleClickManifest(val) {
      // console.log(val);
      // console.log(val.id_manifest);
      if (val.rest_api === "pp") {
        this.$router
          .push({ name: "manifestPp", params: { id: val.id_manifest } })
          .catch((err) => {});
      } else if (val.rest_api === "supplier") {
        this.$router
          .push({ name: "manifestPurchasing", params: { id: val.id_manifest } })
          .catch((err) => {});
      }
    },
    handlePrint(item) {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "wo/cetak_laporan_wo",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_wo: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.pageLoading = false;
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          this.printLoad.manifest = false;
          let responses = Object.assign({}, err.response.data);
          if (responses.message && responses.status==false){
            this.displayMessageValue("error-other", responses.message);
          }else{
            this.displayMessageValue("error", responses);
          }
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "wo",
        id_manifest: this.id,
        code_trans: this.data.manifest.no_wo,
        kode_project: this.data.manifest.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "editWO",
        params: { id: this.id, type: "revised" },
      });
    },
    handleclosetrans (){
      this.visiblemenupopover  = false;
      this.visibleCloseForm    = true;
      
      this.loadtableclose      = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "wo/close_wo",
        params: {
          id_wo : this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response.data.data){
            this.tableClosewo = response.data;
          }else{
            this.visibleCloseForm = false;
           this.displayMessageValue("success-other", response.data.message);
           this.$router.go(0);
          }
          this.loadtableclose=false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleChangeClosewo (value, key, column) {
      const newData = [...this.tableClosewo.data]
      const target = newData.filter(item => key === item.id_pp_dtl)[0]
      if (target) {
        target[column] = value
        this.tableClosewo.data = newData
      }
      
      if(this.tempvalClosewo.toFixed(2)==this.tableClosewo.sisa_transfer.toFixed(2)){
        this.disabledClosetranswo=false;
      }else{
        this.disabledClosetranswo=true;
      }
    },
    saveCloseForm(){
      let formData = new FormData();
      formData.append("id_wo", this.id);
      formData.append("tlc", this.getAuth.username);
      this.tableClosewo.data.forEach((item) => {
        formData.append("id_pp_dtl[]", item.id_pp_dtl);
        formData.append("value[]", item.value);
      });
      Axios({
        method: "post",
        url: this.$serviceUrl + "wo/close_wo",

        data: formData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.$router.go(0);
          this.displayMessage("success");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleViewclosetrans(){
      this.visibleCloseFormview = true;
    },
    handleviewhistPaymentrefund(){
      this.modalhistPaymentrefund = true;
    },
  },
  mounted() {
    this.fetchManifest();
    Event.$on("confirmMessageReturn", this.handleAction);
    Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("refresh", this.fetchManifest);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
    Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("refresh", this.fetchManifest);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.formTransfer = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = false;
        this.search = "";
      }
    },
    histpaymentRefundsearch() {
      if (this.histpaymentRefundsearch) {
        this.histpaymentData = this.histpaymentDatatemp.filter(
          (obj) =>
            obj.job.toLowerCase().indexOf(this.histpaymentRefundsearch.toLowerCase()) >= 0
        );
      }

      if (!this.histpaymentRefundsearch) {
        this.histpaymentData = this.histpaymentDatatemp;
      }

      return this.tableData;
    },
  },
};
</script>

<style></style>
